import { FC } from "react";
import Warning from "../../../UI/Icons/Warning";
import { useAppSelector } from "../../../../store";
import { formatDateToReadable, getDateLabel, getDocumentDate, getDocumentName, isIssuedType, isOneMonthBefore } from "../../../../utils/documentHelper";

const ComplainceCheck: FC = () => {
  const qualificationsData = useAppSelector(
    (state) => state.onboarding.userpersonaldetails?.documents_expire_one_month_documents
  );

  const orderedTypes = ["police_check", "working_with_children_check"];

  const filteredDocs = orderedTypes
    .map((type) => qualificationsData?.find((doc) => doc.document_type === type))
    .filter(Boolean); // remove undefined if any type is missing

  const matchedMultipleTitles: string[] = [];
  const expiredTitles: string[] = [];

  const documentLabels: Record<string, string> = {
    police_check: "Police Check",
    working_with_children_check: "Working With Children",
  };
  
  qualificationsData?.forEach((doc) => {
      const match = orderedTypes.find((config) => config === doc.document_type);

      if (!match) return;

      const title = match;
      const isExpired = doc.is_expired === 1;

      if (isExpired) {
        expiredTitles.push(documentLabels[title]);
      } else {
        matchedMultipleTitles.push(`${documentLabels[title]} needs to be renewed by ${formatDateToReadable(doc.validity_date)}`);
      }
  });

  const formattedExpired = expiredTitles.join(", ");
  const formattedMultipleTitles = matchedMultipleTitles.join(", ");
  
  return (
    <>
      { (formattedExpired.length > 0 || formattedMultipleTitles.length > 0) ? 
        <div className="bg-teal-light px-15px py-10px radius-8px d-flex gap-6">
          <Warning />
          <div className="fs-13 fw-400 text-black">
            Your {" "}
            {formattedExpired.length > 0 && formattedMultipleTitles.length > 0 ? (
                <>
                  <span className="fw-400">{formattedExpired}</span> needs to be renewed and{" "}
                  <span className="fw-400">{formattedMultipleTitles}</span>.
                </>
            ) : formattedExpired.length > 0 ? (
                <>
                  <span className="fw-400">{formattedExpired}</span> needs to be renewed.
                </>
            ) : formattedMultipleTitles.length > 0 ? (
                <>
                  <span className="fw-400">{formattedMultipleTitles}</span>.
                </>
            ) : (
                ""
            )}{" "} 
            Please ensure these are updated in order to continue searching and accepting jobs on Connected Crew.
          </div>
        </div>
      : "" }
      <div className="d-flex flex-column gap-20">
        { filteredDocs?.map((doc, idx, filteredDocs) => (
            <>
              <div className="d-flex flex-column gap-10" key={idx}>
                <div className="fs-13 fw-700 text-black text-capitalize">
                  {getDocumentName(doc.document_type)}
                </div>
                { doc.document_type !== "ACECQA_assessment" ? 
                  <div className="d-flex flex-row gap-5">
                    <div className="fs-13 fw-400 text-grey-dark">
                      {getDateLabel(doc.document_type)}:{" "}
                    </div>
                    <span
                      className={`fs-13 ${
                        isOneMonthBefore(doc?.validity_date ?? "")
                          ? "fw-700 text-alert"
                          : "fw-400 text-grey-dark"
                      }`}
                    >
                      {isIssuedType(doc.document_type) ? (
                        <>
                          {formatDateToReadable(doc.issued_date) || "Not provided"} | Valid until:{" "}
                          <span className={`${
                            doc.is_expired
                              ? "fw-700 text-alert"
                              : isOneMonthBefore(doc?.validity_date)
                              ? "fw-700 text-alert"
                              : "fw-400 text-grey-dark"
                          }`}>
                            {formatDateToReadable(doc?.validity_date) || "Not provided"}
                          </span>
                        </>
                      ) : (
                        formatDateToReadable(getDocumentDate(doc)) || "Not provided"
                      )}
                    </span>
                  </div> 
                : "" }
              </div>
              {/* Add separator only if it's not the last item */}
              {/* {idx < filteredDocs.length - 1 && ( */}
                <div className="bg-off-white min-h-1px"></div>
              {/* )} */}
            </>
          ))
        }
      </div>
    </>
  )
}

export default ComplainceCheck;